<template>
  <v-dialog
    :model-value="modelValue"
    max-width="420"
    scrim="rgba(15, 23, 32, 0.55)"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card class="lms-notice-dialog" :class="`lms-notice-dialog--${tone}`">
      <div class="lms-notice-dialog__icon" aria-hidden="true">
        <v-icon :icon="iconForTone" size="36" />
      </div>
      <v-card-title class="lms-notice-dialog__title">{{ title }}</v-card-title>
      <v-card-text class="lms-notice-dialog__body">{{ message }}</v-card-text>
      <v-card-actions class="lms-notice-dialog__actions">
        <v-spacer />
        <v-btn
          :color="buttonColor"
          variant="flat"
          @click="$emit('confirm')"
        >
          {{ confirmLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  title: { type: String, default: 'Notice' },
  message: { type: String, default: '' },
  confirmLabel: { type: String, default: 'OK' },
  tone: { type: String, default: 'success' }
})

defineEmits(['update:modelValue', 'confirm'])

const iconForTone = computed(() => {
  switch (props.tone) {
    case 'error':
      return 'mdi-alert-circle-outline'
    case 'warning':
      return 'mdi-alert-outline'
    case 'info':
      return 'mdi-information-outline'
    default:
      return 'mdi-check-circle-outline'
  }
})

const buttonColor = computed(() => {
  if (props.tone === 'error') return 'error'
  if (props.tone === 'warning') return 'warning'
  return 'primary'
})
</script>

<style scoped>
.lms-notice-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.lms-notice-dialog__icon {
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  margin: 22px 22px 0;
  border-radius: 14px;
  background: rgba(11, 126, 164, 0.12);
  color: #0b7ea4;
}

.lms-notice-dialog--success .lms-notice-dialog__icon {
  background: rgba(46, 125, 50, 0.12);
  color: #2e7d32;
}

.lms-notice-dialog--error .lms-notice-dialog__icon {
  background: rgba(211, 47, 47, 0.12);
  color: #d32f2f;
}

.lms-notice-dialog--warning .lms-notice-dialog__icon {
  background: rgba(237, 108, 2, 0.12);
  color: #ed6c02;
}

.lms-notice-dialog__title {
  padding-top: 14px !important;
  font-family: Outfit, 'Source Sans 3', sans-serif;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.lms-notice-dialog__body {
  color: var(--lms-text-secondary, #5b6b76);
  font-size: 0.95rem;
  line-height: 1.45;
}

.lms-notice-dialog__actions {
  padding: 8px 16px 16px !important;
}
</style>
